<template>
  <v-row>
    <v-col
      cols="12"
    >
      <base-card>
        <v-card-text>
          <v-card-title>
            Listados Credenciales TEF
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer/>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="details"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.tef_type_code`]="{ item }">
              <div
                v-if="item.tef_type_code === 1"
              >
                <span
                  class="ml-0 mr-2 black--text v-chip v-chip--label
                theme--light v-size--small green lighten-4"
                >
                  <span class="v-chip__content"> DATAFAST </span>
                </span><strong>PinPad</strong>
              </div>

              <div
                v-if="item.tef_type_code === 2"
              >
                <span
                  class="ml-0 mr-2 black--text v-chip v-chip--label
                theme--light v-size--small blue lighten-4"
                >
                  <span class="v-chip__content"> MEDIANET </span>
                </span><strong>PinPad</strong>
              </div>
            </template>

            <template v-slot:[`item.terminales`]="{ item }">
              <router-link
                :to="`/app/administration/tefConfigTerminals?Tef=${item.tef_type_code}&Client=${item.client}`"
                @click.native=""
              >
                <v-icon
                  class="mr-2"
                  color="info darken-3"
                  style="cursor: pointer"
                >
                  mdi-desktop-classic
                </v-icon>
              </router-link>
            </template>

            <template v-slot:[`item.bines`]="{ item }">
              <router-link
                :to="`/app/administration/tefBines?Client=${item.client}`"
                @click.native=""
              >
                <v-icon
                  class="mr-2"
                  color="info darken-3"
                  style="cursor: pointer"
                >
                  mdi-bank
                </v-icon>
              </router-link>
            </template>

          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>

  export default {
    name: 'ShowCredentialsTef',
    data () {
      return {
        search: '',
        headers: [
          {
            text: 'Cliente',
            value: 'client',
          },
          {
            text: 'Tipo Tef',
            value: 'tef_type_code',
            align: 'center',
          },
          {
            text: 'Terminales',
            value: 'terminales',
            align: 'center',
          },
          {
            text: 'Bines',
            value: 'bines',
            align: 'center',
          },
        ],
      }
    },

    computed: {
      details () {
        return this.$store.state.credentialsTef.listCredentials
      },
    },
    created () {
      this.getListCredentials()
    },
    methods: {
      async getListCredentials() {
        await this.$store.dispatch('credentialsTef/getListCredentials')
      },
    },
  }
</script>
